<app-spinner *ngIf="loading$ | async; else content;"></app-spinner>

<ng-template #content>
  <div class="hello-books" *ngIf="site.seoSlug === 'hello-books'">
    <div class="logo"></div>
    <div class="header"></div>
  </div>
  <div class="new-in-books-header" *ngIf="siteSlug === 'new-in-books'">
    <img loading="async" 
      src="https://storage.googleapis.com/wwm-static-content/new-in-books-header.png" 
      alt="https://storage.googleapis.com/wwm-static-content/new-in-books-header.png">
  </div>
  <section id="fs4" *ngIf="siteAdvert">
      <h3>Book Information</h3>
      <p> You are purchasing a <strong>{{site.name}} {{siteAdvert.name}}</strong>
        {{datePreposition}} <strong>{{friendlyPubDate}}</strong>
        at a cost of <strong>{{siteAdvert.price | currency:'USD'}}</strong></p>
      <p>Please enter the book information for your promotion:</p>
      <hr/>
      <form class="form" [formGroup]="form" (ngSubmit)="onSubmit($event)" *ngIf="form">
        <div *ngIf="scrapeInProgress || uploadingCover" class="loading-amazon">
          <app-spinner [label]="!uploadingCover? 'Pulling book information from Amazon' : ''"></app-spinner>
        </div>
        <div [ngClass]="{'hidden': scrapeInProgress || uploadingCover}">
          <div *ngIf="amazonError" class="amazon-error">
            <div class="amazon-text-wrapper">
              <h4 class="amazon-error-text">Amazon Error!</h4>
              <p class="amazon-error-text">
                We’re sorry, it appears that Amazon’s book pulling technology is currently not working. Don't worry! 
                Simply complete the form fields below to book your promotion. You will need to manually upload your book cover image.
              </p>
            </div>
            <div class="amazon-error-close">
              <div class="button amazon close" (click)="dismissAmazonError()"><span class="icon close">&#x00D7;</span></div>
            </div>
          </div>
  
          <div *ngIf="linkError" class="link-error">
            <div class="link-text-wrapper">
              <h4 class="link-error-text">Invalid Book Link URL</h4>
              <p class="link-error-text">
                Please enter a valid URL. If the link is TBD, you can use the "Use a TBD link" button to generate a TBD link for you.
              </p>
            </div>
            <div class="link-error-close">
              <div class="button amazon close" (click)="dismissLinkError()"><span class="icon close">&#x00D7;</span></div>
            </div>
          </div>
        
          <div  class="book-info">
            <div class="cover">
              <app-file-drop
                [bookUrl]="featuredBook._book.amazonImageUrl ? featuredBook._book.amazonImageUrl : defaultCoverImage"
                (loading)="isUploadingBookCover($event)"
                (bookUploadData)="bookCoverUpload($event)"
                (bookUploadError)="bookCoverUploadError($event)"
              >
              </app-file-drop>
            </div>
            <div class="details">
              <div *ngIf="siteAdvert.allowNonAmazonPrimaryLinks else standardLink">
                <div class="non-amazon flex" *ngIf="isBestDeal === false">
                  <div class="highlight-red">New:&nbsp;</div>
                  You can now link to your author store
                  <a class="learn-more" (click)="openLearnMoreNonAmazonLink()">&nbsp;learn more</a>
                </div>
                <app-form-input 
                  [input]="formComponents.link" 
                  [form]="form"
                  (blurHappened)="handleScrapeUndeterminedLink()" 
                  (keydown)="handleKeyDownUndeterminedLink($event)" 
                ></app-form-input>
                <div class="use-tbd" (click)="setTBDURL()">Use a TBD link</div>
              </div>
              <ng-template #standardLink>
                <app-form-input
                  *ngIf="bookType === 'amazon'"
                  [input]="formComponents.amazonLink" 
                  [form]="form" 
                  (blurHappened)="scrapeLink()" 
                  (keydown)="handleKeyDown($event)" 
                  (inputButton)="scrapeLink()" 
                ></app-form-input>
                <div class="form-line" *ngIf="bookType === 'TBD'">
                  <div class="col-50">
                    <input type="text" class="tbd" value="TBD - I will get you my book link later" disabled>
                  </div>
                </div>
  
                <div *ngIf="bookType === 'bookShelf'">
                  <div class="dropdown-select flex ng-star-inserted" [style]="{'margin-bottom': showBookShelf ? '50px': 0 }" (click)="showBookShelf = !showBookShelf">
                    <div class="shelf-select flex-grow-1">
                      {{ selectedFromBookShelf && book?.title ? book.title : 'Select' }}
                    </div> 
                    <span class="icon-arrow-down"></span>
                  </div>
                  <app-book-shelf-search
                    *ngIf="showBookShelf"
                    (bookSelected)="selectBook($event)"
                    (closeBookShelfSearch)="showBookShelf = false"
                  ></app-book-shelf-search>
                </div>
                <a class="flex" *ngIf="linkOptionsAvailable" (click)="showLinkOptions = !showLinkOptions" [class]="{'negative-top-margin': bookType === 'amazon'}">
                  Link Options 
                  <div class="triangle-down"></div>
                </a>
                <div 
                  class="card link-options flex flex-direction-column gap-10" 
                  [class]="{'negative-top-margin-10': bookType === 'amazon'}" 
                  *ngIf="showLinkOptions"
                >
                  <div [class]="{'bold-underline': bookType === 'TBD'}" (click)="selectBookLinkType('TBD');"><a>My book isn't live yet, use TBD for now</a></div>
                  <div  [class]="{'bold-underline': bookType === 'bookShelf'}" *ngIf="user" (click)="selectBookLinkType('bookShelf')"><a>Pick a book from my bookshelf</a></div>
                  <div [class]="{'bold-underline': bookType === 'amazon'}" (click)="selectBookLinkType('amazon')"><a>Automatically pull the book using my Amazon Link</a></div>
                </div>
              </ng-template>
              <app-form-input [class]="{'top-margin': bookType !== 'amazon'}" [input]="formComponents.title" [form]="form"></app-form-input>
              <app-form-input *ngIf="formComponents.author" [input]="formComponents.author" [form]="form"></app-form-input>
              <app-form-input *ngIf="formComponents.narrator" [input]="formComponents.narrator" [form]="form"></app-form-input>
              <app-form-input *ngIf="formComponents.similarAuthors" [input]="formComponents.similarAuthors" [form]="form"></app-form-input>
              <div *ngIf="user?.username">
                <p><strong>Email: </strong>{{user.username}}</p>
              </div>
              <app-form-input *ngIf="!user?.username" [input]="formComponents.email" [form]="form"></app-form-input>
              <div class="name-split">
                <app-form-input class="left" [input]="formComponents.firstName" [form]="form"></app-form-input>
                <app-form-input class="right" [input]="formComponents.lastName" [form]="form"></app-form-input>
              </div>
            </div>
          </div>
          <hr/>
          <div class="more-details">
            <div class="promo-price" [ngClass]="{'price-extended': isBestDeal}" *ngIf="displayPromoPriceField() && siteSlug !== 'new-in-books'">
              <app-form-input 
                *ngIf="formComponents.bookPriceDuringPromo" 
                [input]="formComponents.bookPriceDuringPromo" 
                [form]="form"
              ></app-form-input>
              <div class="best-deal" *ngIf="isBestDeal">
                  This must be your lowest price and match the store link entered above.
              </div>
              <div *ngIf="invalidPrice" class="error-text invalid-price">
                Your book does not match the price requirements for this promotion. Please update or consider purchasing a different promotion.
              </div>
            </div>
            <div *ngIf="siteSlug === 'new-in-books'">
              <div class="price-genre">
                <app-form-input style="padding: 0px" [input]="formComponents.bookPriceDuringPromo" [form]="form"></app-form-input>
                <span *ngIf="invalidPrice" class="error-text">
                  Your book does not match the price requirements for this promotion. Please update or consider purchasing a different promotion.
                </span>
                <!-- <app-form-input [input]="formComponents.bookGenres" [form]="form"></app-form-input> -->
              </div>
              <app-form-input [input]="formComponents.description" [form]="form"></app-form-input>
              <div 
                class="description-counter" 
                *ngIf="form.controls['description'].value" 
                [ngClass]="{'alert': form.controls['description'].value.length > 350}"
              >
                {{form.controls['description'].value.length}} characters
              </div>
              <div class="available" *ngFor="let retailer of retailers">
                <div>
                  <app-form-input [input]="formComponents[retailer.name]" [form]="form"></app-form-input>
                  <app-tooltip-card
                      style="position: relative; top: -74px; left: 317px;"
                      *ngIf="formComponents[retailer.name]?.tooltipText" 
                      [label]="formComponents[retailer.name]?.tooltip" 
                      [text]="formComponents[retailer.name]?.tooltipText"
                    ></app-tooltip-card>
                </div>
                <div class="url">
                  <app-form-input 
                    *ngIf="form.controls[retailer.name].value" 
                    [input]="formComponents[retailer.linkName]" 
                    [form]="form"
                  ></app-form-input>
                </div>
              </div> 
              <app-form-input *ngIf="formComponents.kindleUnlimited" [input]="formComponents.kindleUnlimited" [form]="form"></app-form-input>
            </div>
            <div *ngIf="siteSlug === 'audio-thicket'" [ngClass]="{'pt': isBestDeal}">
              <app-form-input  [input]="formComponents.description" [form]="form"></app-form-input>
              <div 
                class="description-counter" 
                *ngIf="form.controls['description'].value" 
                [ngClass]="{'alert': form.controls['description'].value.length > 350}"
              >
                {{form.controls['description'].value.length}} characters
              </div>
              <ng-container *ngIf="isBestDeal === false">
                <div class="retailer-label">
                  <p class="retailers">On which retailers is your book discounted?</p>
                  <p class="price">Price</p>
                  <div class="primary-link">
                    <p>Primary Link</p>
                    <span class="tooltip-icon" (mouseenter)="primaryLinkHoverIn()" (mouseleave)="primaryLinkHoverOut()">?</span>
                    <div *ngIf="primaryLinkHover">
                      <p class="primaryLinkHelp">The Primary Link will be the link readers are taken to when clicking the cover image or title.</p>
                    </div>
                  </div>
                </div>
                <hr class="horizontal-line">
                <div class="available-atk" *ngFor="let retailer of retailers">
                  <div class="retailer">
                    <app-form-input [input]="formComponents[retailer.name]" [form]="form"></app-form-input>
                    <app-tooltip-card
                        style="position: relative; top: -74px; left: 317px;"
                        *ngIf="formComponents[retailer.name]?.tooltipText" 
                        [label]="formComponents[retailer.name]?.tooltip" 
                        [text]="formComponents[retailer.name]?.tooltipText"
                      ></app-tooltip-card>
                  </div>
                  <div class="url">
                    <app-form-input 
                      *ngIf="form.controls[retailer.name].value" 
                      [input]="formComponents[retailer.linkName]" 
                      [form]="form"
                    ></app-form-input>
                  </div>
                  <div class="price">
                    <app-form-input 
                      *ngIf="form.controls[retailer.name].value" 
                      [input]="formComponents[retailer.priceName]" 
                      [form]="form"
                    ></app-form-input>
                  </div>
                  <div class="primary-link">
                    <input 
                      *ngIf="form.controls[retailer.name].value" 
                      type="radio" 
                      class="toggle-input" 
                      name="isPrimaryLink"  
                      value="{{formComponents[retailer.name + 'IsPrimaryLink'].value}}" 
                      (change)="handlePrimaryLinkUpdate($event)" 
                    >
                  </div>
                </div>
              
            </ng-container>
            </div>
            <div *ngIf="siteSlug !== 'new-in-books' && siteSlug !=='audio-thicket'">
              <app-form-input [input]="formComponents.description" [form]="form"></app-form-input>
              <div 
                class="description-counter" 
                *ngIf="form.controls['description'].value" 
                [ngClass]="{'alert': form.controls['description'].value.length > 350}"
              >
                  {{form.controls['description'].value.length}}
              </div>
              <div>
                <div class="available" *ngFor="let retailer of retailers">
                  <div>
                    <app-form-input [input]="formComponents[retailer.name]" [form]="form"></app-form-input>
                    <app-tooltip-card
                      style="position: relative; top: -74px; left: 317px;"
                      *ngIf="formComponents[retailer.name]?.tooltipText" 
                      [label]="formComponents[retailer.name]?.tooltip" 
                      [text]="formComponents[retailer.name]?.tooltipText"
                    ></app-tooltip-card>
                  </div>
                  <div class="url">
                    <app-form-input 
                      *ngIf="form.controls[retailer.name].value" 
                      [input]="formComponents[retailer.linkName]" 
                      [form]="form"
                    ></app-form-input>
                  </div>
                </div>
              </div>
              <app-form-input 
                *ngIf="siteSlug !== 'bargain-booksy' && form.controls['bookFree']" 
                [toggleOn]="formComponents.bookFree.value" 
                [input]="formComponents.bookFree" 
                [form]="form"
              ></app-form-input>
              <app-form-input *ngIf="form.controls['bookFree'] && form.controls['bookFree'].value" 
                [input]="formComponents.permafree" 
                [form]="form"></app-form-input>
              <div *ngIf="form.controls['permafree'].value === 'NO' && form.controls['bookFree'] && form.controls['bookFree'].value" class="free-dates">
                <app-form-input [input]="formComponents.freeStartDate" [form]="form"></app-form-input>
                <app-form-input [input]="formComponents.freeEndDate" [form]="form"></app-form-input>
              </div>
              <app-form-input *ngIf="formComponents.kindleUnlimited" [input]="formComponents.kindleUnlimited" [form]="form"></app-form-input>
            </div>
            <div *ngIf="siteSlug === 'red-feather-romance'">
              <app-form-input [input]="formComponents.bookLength" [form]="form"></app-form-input>
              <app-form-input [input]="formComponents.nameOfSeries" [form]="form"></app-form-input>
              <app-form-input [input]="formComponents.numberOfBooksInSeries" [form]="form"></app-form-input>
              <app-form-input [input]="formComponents.bookNumber" [form]="form"></app-form-input>
              <app-form-input [input]="formComponents.primarySubgenre" [form]="form"></app-form-input>
              <app-form-input [input]="formComponents.threesomesOrRomanticScenes" [form]="form"></app-form-input>
              <app-form-input [input]="formComponents.endingOfBook" [form]="form"></app-form-input>
              <app-form-input [input]="formComponents.cheatingOrInfidelity" [form]="form"></app-form-input>
              <app-form-input [input]="formComponents.commonThemes" [form]="form"></app-form-input>
            </div>
            <app-form-input *ngIf="formComponents.kindleCountdownDeal" [input]="formComponents.kindleCountdownDeal" [form]="form"></app-form-input>
            <div *ngIf="(featuredBook._book.isSeries && featuredBook._siteAdvert.isSeries) || featuredBook._siteAdvert.isSeries" class="series">
              <button type="button" class="regular button" (click)="addSeries()">ADD BOOK TO THIS SERIES</button>
              <div *ngFor="let link of seriesLinks; let i = index" class="link-box">
                <div class="row">
                  <span class="icon" (click)="removeSeries(i)">&#xf36e;</span>
                  <div class="link">
                    <p class="head"><strong>Amazon Link: </strong></p>
                    <input type="text" [id]="link.id" [value]="link.value">
                    <p class="helper">i.e. 'http://amazon.com/Your-Awesome-Book-Name'</p>
                  </div>
                  <div class="price">
                    <p class="head"><Strong>Price: </Strong></p>
                    <div class="price-input">
                      <span class="dollar">$</span>
                      <div class="text-width">
                        <input type="number" [id]="'price_'+link.id" [value]="link.price">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!isFbAdCampaign && !site.hideSubscriptionToReaderList">
              <app-form-input [input]="formComponents.subscribeToList" [form]="form"></app-form-input>
            </div>
          </div>
          <div class="button-line">
            <div class="terms">
              <div [formGroup]="form">
                <input 
                  id="terms"
                  [value]="form.value.terms"
                  type="checkbox"
                  formControlName="terms"
                  class="form-control"
              >
              </div>
              
              By checking this box, you agree to Written Word Media's 
              <a href = 'https://www.writtenwordmedia.com/terms' target="_blank">Terms of Service</a> and 
              <a href="https://www.writtenwordmedia.com/terms" target="_blank">Privacy Policy</a>
            </div>
            <button type="submit" class="button regular solid-green" 
              [disabled]="!form.value.terms || inProgress">{{ inProgress? 'Processing...' : 'Continue' }}</button>
  
            <div *ngIf="validation.display" class="card validation-flyout" (appClickOutside)="closeValidationFlyout()">
              <div class="flex">
                <div>
                  <h3>Still a little work to do</h3>
                  <p>There are {{ validation.fields.length }} required field(s) you still have to fill out before proceeding</p>
                  <ul>
                    <li *ngFor="let field of validation.fields">
                      <a (click)="scrollToField(field.id)">{{ field.name }}</a>
                    </li>
                  </ul>
                </div>
                <div class="align-content-end">
                  <img src="https://storage.googleapis.com/wwm-static-content/book-owl.png" alt="Owl Helper" />
                </div>
              </div>
            </div>
  
          </div>
        </div>
      </form>
    <!-- <div> -->
    <!-- </ng-template> -->
  </section>
  <app-modal id="learn-more-non-amazon-link">
    <aside class="modal">
      <div class="modal-body">
        <div class="header">
          <div class="title-text" >Direct Sales Now Supported</div>
          <div class="close" (click)="closeLearnMoreNonAmazonLink()"><span class="icon">&#x00D7;</span></div>
        </div>
        <div class="upsell-block">
          <p>
            You can now add either a retailer link (Amazon, Apple, etc...) or a link to your author store where the reader can buy the book directly.
          </p>
        </div>
        <div class="flex flex-column">
          <button class="button regular solid-green full-width" (click)="closeLearnMoreNonAmazonLink()">Sounds Good</button>
        </div>
      </div>
    </aside>
    <div class="modal-background"></div>
  </app-modal>
</ng-template>
<app-new-error-modal [options]="errorOptions" modalId="fs4-error-modal"></app-new-error-modal>